import initReleases from '~/releases/mount_index';

document.addEventListener('DOMContentLoaded', initReleases);
